<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>HPP</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th width="50" rowspan="2">No</th>
                  <th width="100" rowspan="2">Descriptions</th>
                  <th width="200" colspan="4">QTY</th>
                  <th width="100" rowspan="2">U/P</th>
                  <th width="100" rowspan="2">Rp</th>
                  <!-- <th width="100" rowspan="2">HPP</th> -->
                  <th width="100" rowspan="2">Harga Jual</th>
                  <th width="100" rowspan="2">Laba Per Produk</th>
                </tr>
                <tr>
                  <th width="50">Saldo Awal</th>
                  <th width="50">Pembelian</th>
                  <th width="50">Penjualan</th>
                  <th width="50">Saldo Akhir</th>
                </tr>
              </thead>
              <tbody v-for="(v, k) in data.data" :key="k">
                <tr>
                  <td>
                    <table-number-2 :index="k" :paginate="data.paginate" />
                  </td>
                  <td>{{ v.name }}</td>
                  <td class="text-right">{{ v.last_month.qty }}</td>
                  <td class="text-right">{{ v.buy.qty }}</td>
                  <td class="text-right">{{ v.use.qty }}</td>
                  <td class="text-right">{{ v.current.qty }}</td>
                  <td class="text-right">
                    {{ v.current.up | thousandSeparator }}
                  </td>
                  <td class="text-right">
                    {{ v.current.rp | thousandSeparator }}
                  </td>
                  <!-- <td class="text-right">
                    {{ v.base_price | thousandSeparator }}
                  </td> -->
                  <td class="text-right">
                    <!-- ditambah harga per jenis customer -->
                    {{ v.price | thousandSeparator }}
                  </td>
                  <td class="text-right">
                    <!-- ditambah laba per customer -->
                    {{ (v.price - v.base_price) | thousandSeparator }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <paginator :paginator="data.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import Paginator from '../../components/Paginator.vue'
import TableNumber2 from '../../components/TableNumber2.vue'
import { HTTPAUTH } from '../../lib/httplib'
export default {
  data () {
    return {
      data: {}
    }
  },
  components: { Paginator, TableNumber2 },
  created () {
    this.getList(1)
  },
  methods: {
    changePage (page) {
      this.getList(page)
    },
    getList (page) {
      HTTPAUTH.get(`/api/balance/purchase?page=${page}&size=10`).then(res => {
        this.data = res.data
        this.$router.push({ query: { page: page } })
      })
    }
  }
}
</script>